module.exports = __webpack_public_path__ + "0db6d7f8316df66730e5b4a557446b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/bespoke_bg_m@3x.jpg
// module id = 660
// module chunks = 0